<script>
import Dollar from '@/components/icons/Dollar.vue'

export default {
  name: 'DollarPrice',
  components: { Dollar },

  props: {
    priceRange: {
      type: String,
      required: true,
    },
  },

  computed: {
    count() {
      return this.priceRange?.length
    },

    countFaded() {
      return 5 - this.priceRange?.length
    },
  },
}
</script>

<template>
  <span class="inline-flex items-center justify-start gap-0.5">
    <Dollar
      v-for="n in count"
      :key="n"
      class="h-3 w-3" />
    <Dollar
      v-for="n in countFaded"
      :key="n + count"
      class="h-3 w-3 fill-neutral-300" />
  </span>
</template>
